import { useTranslations } from "@jugl-web/utils";
import { useFormattedDate } from "@jugl-web/utils/hooks/useFormattedDate";
import { isBefore, subDays, endOfDay } from "date-fns";
import { Tooltip } from "@jugl-web/ui-kit";
import { TableDateCell } from "@jugl-web/ui-kit/data-display/Table";
import { ReactComponent as WarningIcon } from "./assets/warning.svg";

interface ComponentProps {
  due_on: string | null;
  useConciseFormat?: boolean;
}

export const DueDateCell: React.FC<ComponentProps> = ({
  due_on,
  useConciseFormat = false,
}) => {
  const { formatDateLabel } = useFormattedDate();
  const yesterday = endOfDay(subDays(new Date(), 1));
  const dueOnDate = due_on ? new Date(due_on) : null;
  const isPastDue = dueOnDate ? isBefore(dueOnDate, yesterday) : false;

  if (useConciseFormat) {
    const fullDateLabel = dueOnDate ? formatDateLabel(dueOnDate, "full") : null;

    return (
      <Tooltip
        placement="top"
        renderTrigger={({ props, ref }) => (
          <div ref={ref} {...props}>
            <TableDateCell
              date={dueOnDate}
              format={{ type: "date", variant: "concise" }}
              endContent={isPastDue && <PastDueDateTooltip />}
            />
          </div>
        )}
      >
        {fullDateLabel}
      </Tooltip>
    );
  }

  return (
    <TableDateCell
      date={dueOnDate}
      endContent={isPastDue && <PastDueDateTooltip />}
    />
  );
};

const PastDueDateTooltip = () => {
  const { t } = useTranslations();

  return (
    <Tooltip
      delay="none"
      placement="right"
      renderTrigger={({ props, ref }) => (
        <WarningIcon ref={ref} className="shrink-0" {...props} />
      )}
    >
      {t({
        defaultMessage: "This invoice is past its due date",
        id: "invoices.past-due",
      })}
    </Tooltip>
  );
};
